export default __webpack_public_path__ + "static/media/island_8.a06ab35d.png";